<template>
  <main id="app">
    <div v-if="error.message" class="error">
      {{ error.message }}
    </div>
    <div v-if="loading" class="loading">
      <div class="basic"></div>
    </div>
    <template v-else>
      <Title @handleControlChange="handleControlChange" :intro-text="settings.IntroText" :filter-groups="filterGroups" />
      <Wheel @selection="handleSelection" :controls="controls" :filtered-items="filteredItems" :settings="settings" />
      <Info @animationOver="animationOver" :selected="selectedItem" :change="triggerChange" />
    </template>
  </main>
</template>

<script>
import Title from './components/Title.vue'
import Wheel from './components/Wheel.vue'
import Info from './components/Info.vue'

import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)

export default {
  name: 'App',
  components: {
    Wheel,
    Title,
    Info
  },
  data() {
    return {
      loading: true,
      selectedItem: {},
			controls: [],
      triggerChange: false,
      originalItems: [],
      filteredItems: [],
      settings: {},
      api: '/api/campaign/jif',
      error: {},
      filterGroups: [
        {
          title: 'Jif Type',
          filters: []
        },
        {
          title: 'Dish Type',
          filters: []
        },
        {
          title: 'Service',
          filters: []
        }
      ]
    }
  },
  mounted () {
    let host = (process.env.NODE_ENV === 'development') ? 'https://smuckerawayfromhome.com' : ''
    Vue.axios.get(host + this.api).then((response) => {
      this.originalItems = response.data.recipes ? response.data.recipes : []
      this.settings = response.data.settings ? response.data.settings : {}
      this.loading = false
      this.createFilters()
    }).catch(e => {
      this.error = e
    })
  },
  watch: {
    selectedItem: function() {
      this.triggerChange = true
    },
    controls(newSetting, oldSetting) {
      if (newSetting !== oldSetting) {
        this.filter()
      }
    }
  },
  methods: {
    createFilters() {
      this.originalItems.forEach(item => {
          if (item.AllTags) {
            item.AllTags.forEach(tag => {
              // for each tag in each item, check if it's parent tag matches a tag group
              if (tag.parent.name) {
                this.filterGroups.forEach(group => {
                  if (tag.parent.name === group.title) {
                    // if it does, check if the tag is already in the group
                    let found = group.filters.find(filter => {
                      return filter.name === tag.name
                    })
                    // if it's not, add it
                    if (!found) {
                      group.filters.push(tag)
                    }
                  }
                })
              }
            })
          }
      })
      this.filter()
    },
    filter() {
      // TODO: WHOLE NEW FUNCTION GOES HERE
      
      let newArray = []
      if (typeof this.controls !== 'undefined' && this.controls.length > 0) {
        // addative filtering
          this.originalItems.forEach(item => {
            let found = false
            if (item.AllTags) {
              item.AllTags.forEach(tag => {
                this.controls.forEach(control => {
                  if (tag.name === control) {
                    found = true
                  }
                })
              })
            }
            if (found) {
              newArray.push(item)
            }
          })
      //   if (this.controls === 'on-the-side') {
      //     newArray = this.originalItems.filter((i) => {
      //       return i.RecipeType === 'on-the-side'
      //     })
      //   } else if (this.controls === 'in-the-dish') {
      //     newArray = this.originalItems.filter((i) => {
      //       return i.RecipeType === 'in-the-dish'
      //     })
      //   } else {
      //     newArray = this.originalItems
      //   }
      this.filteredItems = newArray
      } else {
        this.filteredItems = this.originalItems
      }
    },
    handleSelection(item) {
      this.selectedItem = item
    },
    handleControlChange(controls) {
      this.controls = controls
    },
    animationOver() {
      this.triggerChange = false
    }
  },
}
</script>

<style lang="scss">

@import './styles/style.scss';

#app {
  background-image: url(https://s3.us-east-2.amazonaws.com/afh-www/site/assets/AwayFromHome/Campaigns/Jif-Tool/pb-swirls-mobile.jpg);
  background-size: 556px 632px;
  background-position: center top;
  background-repeat: repeat-y;
  display: grid;
  scroll-behavior: smooth;
  @include breakpoint(xmedium down) {
    grid-template-rows: auto 32vh auto;
  }
  // @media only screen and (max-width: $large) and (min-height: 700px) {
  //   grid-template-rows: 48vh 32vh auto;
  // }
  @include breakpoint(556px) {
    background-size: 1112px 1264px;
  }
  // @include breakpoint(xmedium) {
  //   grid-template-rows: 40vh 32vh auto;
  // }
  @include breakpoint(large) {
    background-image: url(https://s3.us-east-2.amazonaws.com/afh-www/site/assets/AwayFromHome/Campaigns/Jif-Tool/pb-swirls-desktop.jpg);
    background-position: center center;
    background-size: cover;
    grid-template-rows: auto;
    grid-template-columns: 1.413fr 1fr 1.413fr;
    min-height: $minHeight;
  }
}

</style>
